import '../blocks/accordion/js/script.js';
import '../blocks/call-to-action/js/script.js';
import '../blocks/container/js/script.js';
import '../blocks/dropdown/js/script.js';
import '../blocks/example/js/script.js';
import '../blocks/icon-text/js/script.js';
import '../blocks/keyvisual/js/script.js';
import '../blocks/notices/js/script.js';
import '../blocks/page-menu/js/script.js';
import '../blocks/postarchive/js/script.js';
import '../blocks/slider/js/script.js';
import '../blocks/tabs/js/script.js';
import '../components/animations/script.js';
import '../components/margin/script.js';
import '../filters/audio/script.js';
import '../filters/table/script.js';
import '../filters/video/script.js';
import '../filters/youtube/script.js';


// WEBPACK FOOTER //
// ./src/js/script.js